import type { FaireProductEntity } from "../../entity_types/product";

export const p_984qk5y7vh: FaireProductEntity = {
  token: "p_984qk5y7vh",
  type: "product",
  name: "Swedish Dishcloth - Flower - Green/Blue",
  brandToken: "b_frbt34h3nt",
  brandName: "Jangneus",
  imageUrl:
    "https://cdn.faire.com/fastly/1b6a6f5a23d5814071f44b061b3d79c323da8cba4aee8d515e5df71b541f7acd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f902d5587a072444bec5d84eefe05fd9cf25fe012c18d09987b6bc25cf14e7c4.jpeg",
  ],
  priceDollars: 3,
  description:
    'These sponge cloths are guaranteed to bring fresh Scandinavian style into your kitchen. Used in Swedish kitchens since the 1950s, these tried and trusted dishcloths are made of all natural and renewable materials. Highly durable, they are great for washing up, general cleaning and mopping up spills. Matching kitchen towels are available to keep your kitchen looking smart and coordinated.  Highly absorbent, they can absorb 15 times its own weight in water. Machine washable. Designed by Jangneus in Sweden. Size: W6.75"x L8". 100% biodegradable. Made of 70% cellulose and 30% cotton',
  tags: [],
  msrpDollars: 6.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:50.304Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
